import React from 'react';
import logo from './logo.svg';
import { BrowserRouter, Routes, Route, Link, Outlet } from 'react-router-dom';
import './App.css';
import StudentLogin from './Pages/StudentLogin/StudentLogin';
import StudentRegistration from './Pages/StudentRegistration/StudentRegistration';
import LeaderBoard from './Pages/LeaderBoard/LeaderBoard';
import Quiz from './Pages/Quiz/Quiz';
import CoursePlayer from './Pages/CoursePlayer/CoursePlayer';
import AdminLogin from './Pages/AdminLogin/AdminLogin';
import Assignment from './Pages/Assignment/Assignment';
import AssignmentMark from './Pages/AssignmentMark/AssignmentMark';
import Dashboard from './Pages/Dashboard/Dashboard';
import Quizzes from './Pages/Quizzes/Quizzes';
import Videos from './Pages/Videos/Videos';
import TopBar from './Components/TopBar/TopBar';
import VideoContainer from './Pages/CoursePlayer/VideoContainer';
import StudentRoute from './Components/StudentRoute/StudentRoute';
import PublicRoute from './Components/PublicRoute/PublicRoute';
import useAuthCheck from './Hooks/useAuthChecked';
import AdminRoute from './Components/AdminRoute/AdminRoute';
import AddVideo from './Pages/AddVideo/AddVideo';
import AddAssignment from './Pages/AddAssignment/AddAssignment';
import AddQuiz from './Pages/AddQuiz/AddQuiz';
import Loading from './Components/UiLoadingComponents/Loading';
import { ToastContainer, } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
function App() {
  const authChecked = useAuthCheck();

  return (
    <>
      {
        !authChecked ?
          <Loading className='center-of-window'></Loading>
          :
          <BrowserRouter>
            <Routes>
              <Route index element={
                <PublicRoute>
                  <StudentLogin />
                </PublicRoute>

              } />
              <Route path='/register' element={
                <PublicRoute>
                  <StudentRegistration />
                </PublicRoute>
              } />
              <Route path='/leaderboard' element={
                <StudentRoute><LeaderBoard /></StudentRoute>
              } />
              <Route path='/quizzes/:videoId' element={
                <StudentRoute>
                  <Quiz />
                </StudentRoute>
              } />
              <Route path='/course' element={
                <StudentRoute>
                  <CoursePlayer />
                </StudentRoute>
              } >

                <Route path='/course/:id' element={<VideoContainer></VideoContainer>} />
              </Route>
              {/* admin routes */}
              <Route path='/admin' element={
                <PublicRoute redirectPath='/admin/dashboard'>
                  <AdminLogin />
                </PublicRoute>
              } />
              <Route path='/admin/dashboard' element={
                <AdminRoute>
                  <Dashboard />
                </AdminRoute>
              } />
              <Route path='/admin/assignment' element={
                <AdminRoute>
                  <Assignment />
                </AdminRoute>
              } />
              <Route path='/admin/add-assignment' element={
                <AdminRoute>
                  <AddAssignment />
                </AdminRoute>
              } />
              <Route path='/admin/assignment-mark' element={
                <AdminRoute>
                  <AssignmentMark />
                </AdminRoute>
              } />
              <Route path='/admin/quizzes' element={
                <AdminRoute>
                  <Quizzes />
                </AdminRoute>
              } />
              <Route path='/admin/addQuiz' element={
                <AdminRoute>
                  <AddQuiz />
                </AdminRoute>
              } />
              <Route path='/admin/videos' element={
                <AdminRoute>
                  <Videos />
                </AdminRoute>
              } />
              <Route path='/admin/addVideo' element={
                <AdminRoute>
                  <AddVideo />
                </AdminRoute>
              } />
            </Routes>

          </BrowserRouter>
      }
      <ToastContainer
        position="bottom-right"
        theme="dark"
      ></ToastContainer>
    </>

  );
}

export default App;
